var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getNewSurveyAction, saveSurveyNewFolderWithCollaborators, saveSurveyNewFolderNoCollaborators, saveSurveyNoFolderWithCollaborators, saveSurveyNoFolderNoCollaborators, saveSurveyExistingFolderNoCollaborators, saveSurveyExistingFolderWithCollaborators, } from "./save-new-survey-helper";
export var NewSurveyAction;
(function (NewSurveyAction) {
    NewSurveyAction[NewSurveyAction["NewFolderWithCollaborators"] = 0] = "NewFolderWithCollaborators";
    NewSurveyAction[NewSurveyAction["NewFolderWithoutCollaborators"] = 1] = "NewFolderWithoutCollaborators";
    NewSurveyAction[NewSurveyAction["ExistingFolderWithCollaborators"] = 2] = "ExistingFolderWithCollaborators";
    NewSurveyAction[NewSurveyAction["ExistingFolderWithoutCollaborators"] = 3] = "ExistingFolderWithoutCollaborators";
    NewSurveyAction[NewSurveyAction["NoFolderWithCollaborators"] = 4] = "NoFolderWithCollaborators";
    NewSurveyAction[NewSurveyAction["NoFolderWithoutCollaborators"] = 5] = "NoFolderWithoutCollaborators";
})(NewSurveyAction || (NewSurveyAction = {}));
export var useSaveNewSearch = function (saveNewSurvey, setSurveys, setSelectedSurvey, newFolderName, createSavedSearchFolder, setFolders, getSubjectsFromContacts, setSurveyContacts, updateFolders) {
    return function (request, collaborators, collaboratorsToRemove) {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _collaborators, _collaboratorsToRemove, newSurveyAction, _a, error_1, error_2, error_3, error_4, error_5, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _collaborators = (collaborators === null || collaborators === void 0 ? void 0 : collaborators.length) > 0 ? collaborators : undefined;
                        _collaboratorsToRemove = (collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) > 0 ? collaboratorsToRemove : undefined;
                        newSurveyAction = getNewSurveyAction(newFolderName, request, _collaborators, _collaboratorsToRemove);
                        if (!(saveNewSurvey &&
                            createSavedSearchFolder &&
                            getSubjectsFromContacts &&
                            setSurveys &&
                            setSelectedSurvey &&
                            setFolders &&
                            setSurveyContacts &&
                            updateFolders)) return [3 /*break*/, 21];
                        _a = newSurveyAction;
                        switch (_a) {
                            case NewSurveyAction.NewFolderWithCollaborators: return [3 /*break*/, 1];
                            case NewSurveyAction.NewFolderWithoutCollaborators: return [3 /*break*/, 5];
                            case NewSurveyAction.ExistingFolderWithCollaborators: return [3 /*break*/, 9];
                            case NewSurveyAction.ExistingFolderWithoutCollaborators: return [3 /*break*/, 12];
                            case NewSurveyAction.NoFolderWithCollaborators: return [3 /*break*/, 15];
                            case NewSurveyAction.NoFolderWithoutCollaborators: return [3 /*break*/, 18];
                        }
                        return [3 /*break*/, 21];
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        if (!newFolderName) return [3 /*break*/, 3];
                        return [4 /*yield*/, saveSurveyNewFolderWithCollaborators(newFolderName, request, collaborators, getSubjectsFromContacts, createSavedSearchFolder, saveNewSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [3 /*break*/, 21];
                    case 4:
                        error_1 = _b.sent();
                        console.error("Error in saving survey with new folder/collaborators: ", error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        _b.trys.push([5, 8, , 9]);
                        if (!newFolderName) return [3 /*break*/, 7];
                        return [4 /*yield*/, saveSurveyNewFolderNoCollaborators(newFolderName, request, createSavedSearchFolder, saveNewSurvey, setFolders, setSurveys, setSelectedSurvey)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [3 /*break*/, 21];
                    case 8:
                        error_2 = _b.sent();
                        console.error("Error in saving survey with new folder/no collaborators: ", error_2);
                        return [3 /*break*/, 9];
                    case 9:
                        _b.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, saveSurveyExistingFolderWithCollaborators(request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateFolders, saveNewSurvey, setSurveys, setSelectedSurvey, setSurveyContacts)];
                    case 10:
                        _b.sent();
                        return [3 /*break*/, 21];
                    case 11:
                        error_3 = _b.sent();
                        console.error("Error in saving survey with existing folder/collaborators: ", error_3);
                        return [3 /*break*/, 12];
                    case 12:
                        _b.trys.push([12, 14, , 15]);
                        return [4 /*yield*/, saveSurveyExistingFolderNoCollaborators(request, saveNewSurvey, setSurveys, setSelectedSurvey)];
                    case 13:
                        _b.sent();
                        return [3 /*break*/, 21];
                    case 14:
                        error_4 = _b.sent();
                        console.error("Error in saving survey with existing folder/no collaborators: ", error_4);
                        return [3 /*break*/, 15];
                    case 15:
                        _b.trys.push([15, 17, , 18]);
                        return [4 /*yield*/, saveSurveyNoFolderWithCollaborators(request, collaborators, getSubjectsFromContacts, saveNewSurvey, setSurveys, setSelectedSurvey, setSurveyContacts)];
                    case 16:
                        _b.sent();
                        return [3 /*break*/, 21];
                    case 17:
                        error_5 = _b.sent();
                        console.error("Error in saving survey with no folder/collaborators: ", error_5);
                        return [3 /*break*/, 18];
                    case 18:
                        _b.trys.push([18, 20, , 21]);
                        return [4 /*yield*/, saveSurveyNoFolderNoCollaborators(request, saveNewSurvey, setSurveys, setSelectedSurvey)];
                    case 19:
                        _b.sent();
                        return [3 /*break*/, 21];
                    case 20:
                        error_6 = _b.sent();
                        console.error("Error in saving survey with no folder/no collaborators: ", error_6);
                        return [3 /*break*/, 21];
                    case 21: return [2 /*return*/];
                }
            });
        }); })();
    };
};
//# sourceMappingURL=use-save-new-search.js.map